module.exports = __webpack_public_path__ + "img/copas-icon.f9b3b00e.svg";